import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "csv-cost",
  components: {
    AppHeader,
  },
  async created() {
    this.getCompany();
    await this.getTargetDate();
  },
  data() {
    return {
      companies: "",
      users: [],
      selectedCompany: localStorage.company_id,
      selectedMonth: "",
      targetDates: [],
      getCompanisEnd: false,
      searchEnd: false,
      attendances: [],
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    getTargetDate() {
      if (this.selectedCompany == 1) {
        let targetYyyyMm = dayjs("2020-04").format("YYYY-MM");
        let endYyyyMm = dayjs().format("YYYY-MM");
        for (;;) {
          if (targetYyyyMm > endYyyyMm) break;
          this.targetDates.unshift({
            text: dayjs(targetYyyyMm).format("YYYY年MM月"),
            value: dayjs(targetYyyyMm).format("YYYY-MM"),
          });
          this.selectedMonth = dayjs(targetYyyyMm).format("YYYY-MM");
          targetYyyyMm = dayjs(targetYyyyMm)
            .add(1, "month")
            .format("YYYY-MM");
        }
      } else {
        let today = new Date();
        let targetYyyyMm = dayjs("2020-04").format("YYYY-MM");
        let endYyyyMm = dayjs().format("YYYY-MM");
        if (today.getDate() >= 16) {
          endYyyyMm = dayjs()
            .add(1, "month")
            .format("YYYY-MM");
        }
        for (;;) {
          if (targetYyyyMm > endYyyyMm) break;
          this.targetDates.unshift({
            text: dayjs(targetYyyyMm).format("YYYY年MM月"),
            value: dayjs(targetYyyyMm).format("YYYY-MM"),
          });
          this.selectedMonth = dayjs(targetYyyyMm).format("YYYY-MM");
          targetYyyyMm = dayjs(targetYyyyMm)
            .add(1, "month")
            .format("YYYY-MM");
        }
      }
    },
    async csvDownload() {
      let data = {
        company_id: this.selectedCompany,
        target_month: this.selectedMonth,
      };
      let res = await this.$store
        .dispatch("GET_COST_CSV", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.downloadCsv(res.data);
    },
    downloadCsv(data) {
      let wkFileName = "概算労務費" + this.selectedMonth + "分.csv";
      const csvFileName = wkFileName;
      let bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      let mimeType = "text/csv";
      let csv = "工事番号,現場名,金額\n";
      data.forEach((obj) => {
        if (obj.site_number) {
          csv += this.enquoteForCSV(obj.site_number) + ",";
        } else {
          csv += ",";
        }
        if (obj.site_name) {
          csv += this.enquoteForCSV(obj.site_name) + ",";
        } else {
          csv += ",";
        }
        if (obj.kingaku) {
          csv += this.enquoteForCSV(obj.kingaku);
        } else {
          csv += "0";
        }
        csv += "\n";
      });
      const blob = new Blob([bom, csv], { type: mimeType });
      let hiddenElement = document.createElement("a");
      hiddenElement.download = csvFileName;
      hiddenElement.target = "_blank";
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, csvFileName);
      } else if (window.URL && window.URL.createObjectURL) {
        hiddenElement.href = window.URL.createObjectURL(blob);
        document.body.appendChild(hiddenElement);
        hiddenElement.click();
        document.body.removeChild(hiddenElement);
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(
          blob
        );
        hiddenElement.click();
      }
    },
    enquoteForCSV: function(val) {
      if (!val) return val;
      if (/[",\r\n]/.test(val)) {
        //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"';
      }
      return val;
    },
  },
};
